import { Component, Input } from '@angular/core';

import { IconComponent } from '../../../common/icon/icon.component';
import { IconName } from '../../../icons-container/icons.type';
import { RadioGroupItem } from '../radio-form-group.component';

@Component({
  standalone: true,
  imports: [IconComponent],
  selector: 'rt-radio-form-group-item',
  templateUrl: './radio-form-group-item.component.html',
  styleUrls: ['./radio-form-group-item.component.less'],
  host: {
    '[class.disabled]': 'disabled',
  },
})
export class RadioFormGroupItemComponent {
  @Input() public icon: IconName;
  @Input() public item: RadioGroupItem;
  @Input() public disabled: boolean = false;
}
